jQuery(document).ready(function () {
    /* Request Service*/

    $("#form_request_service").on("submit", function(e) {
      $("#request_service_btn").addClass("disabled").text("Procesando...");
      $("#home_request_access_modal").addClass("disabled");
    });

    /* Request Access Admin */

    $("#form_request_access_admin").on("submit", function(e) {
      $("#request_access_admin_btn").addClass("disabled").text("Procesando...");
      $("#home_request_access_modal").addClass("disabled");
    });

    function updateButtonAccessAdminState() {
      const hasRadios = $('.client-radio').length > 0;
      const radioValidation = !hasRadios || $('.client-radio:checked').length > 0;
      const hasProducts = $('.product-checkbox').length > 0;
      const productValidation = !hasProducts || $('.product-checkbox:checked').length > 0               
      $('#request_access_admin_btn').prop('disabled', !(radioValidation && productValidation));
    }
  
    $('#home_request_access_modal').on('shown.bs.modal', updateButtonAccessAdminState);
    $(document).on('change', '.client-radio', updateButtonAccessAdminState);
    $(document).on('change', '.product-checkbox', updateButtonAccessAdminState);

    /* Request Active Awareness Digital*/

    function updateButtonActiveAwarenessState() {
      const productValidation = $('.product-awareness-checkbox').length > 0 && $('.product-awareness-checkbox:checked').length > 0
      $('#request_active_awareness_btn').prop('disabled', !productValidation);
    }

    $('#home_request_active_awareness_modal').on('show.bs.modal', function() {
      if ($('#request_active_awareness_btn').hasClass('disabled')) {
        $('#request_active_awareness_btn').removeClass('disabled');
      }
      $('.product-awareness-checkbox').prop('checked', false);
      updateButtonActiveAwarenessState();
    });

    $(document).on('change', '.product-awareness-checkbox', updateButtonActiveAwarenessState);

    $('#form_request_active_awareness').on("submit", function(e) {
      $("#request_active_awareness_btn").addClass('disabled').text("Procesando...");
      $("#home_request_active_awareness_modal").addClass("disabled");
    });

});